import { Box } from '@zillow/constellation-10';

import OnboardingProgressBar from './OnboardingProgressBar';

interface Props {
  progressTitle?: string;
  children: React.ReactNode;
  customCss?: { [key: string]: string };
}
const Page = ({ progressTitle, children, customCss }: Props) => {
  return (
    <Box
      css={{
        display: 'grid',
        gridTemplateColumns: 'repeat(12, 1fr)',
        gap: '24px',
        ...(customCss as any),
      }}
    >
      {progressTitle && (
        <Box
          css={{
            display: 'grid',
            gridColumnStart: 1,
            gridColumnEnd: 'span 12',
          }}
        >
          <OnboardingProgressBar progressTitle={progressTitle} />
        </Box>
      )}
      {children}
    </Box>
  );
};

const MainSection = ({ children, fullWidth = false }) => (
  <Box
    css={{
      display: 'grid',
      gridColumnStart: 1,
      gridColumnEnd: fullWidth ? 'span 12' : { base: 'span 12', lg: 'span 7' },
    }}
  >
    {children}
  </Box>
);

const RightSection = ({ children }) => (
  <Box
    css={{
      display: { base: 'none', lg: 'grid' },
      gridColumnStart: { lg: 9 },
      gridColumnEnd: 'span 4',
    }}
  >
    {children}
  </Box>
);

const BottomSection = ({ children }) => (
  <Box
    css={{
      display: { base: 'grid', lg: 'none' },
      gridColumnStart: 1,
      gridColumnEnd: 'span 12',
    }}
  >
    {children}
  </Box>
);

Page.MainSection = MainSection;
Page.RightSection = RightSection;
Page.BottomSection = BottomSection;
export default Page;
